<h2 mat-dialog-title class="text-align-center">Success!</h2>
<mat-dialog-content class="m-t-1 m-b-1">
  <p class="d-flex justify-content-center">Your password has been changed.</p>
  <p class="d-flex justify-content-center">Please log back in with your new details.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
